import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { EntitlementsService } from './../entitlements/entitlements.service';
import { OAuthService } from 'angular-oauth2-oidc';
import { filter, takeUntil, tap } from 'rxjs/operators';
import { BaseObserver } from '../shared/baseobserver';

@Component({
  selector: 'ssg-auth-callback',
  template: '',
  styles: []
})
export class AuthCallbackComponent extends BaseObserver implements OnInit {

  constructor(private oauthService: OAuthService, private entitlementsService: EntitlementsService, private router: Router) {
    super();
  }

  ngOnInit() {
    this.oauthService.events
      .pipe(
        filter(e => e.type === 'token_received'),
        takeUntil(this.destroy$)
      ).subscribe(e => {
        this.loadEntitlements();
    });

    if (this.oauthService.hasValidIdToken() && this.oauthService.hasValidAccessToken()) {
      this.loadEntitlements();
    } else {
      this.oauthService.tryLogin();
    }
  }

  /* angular-oauth2-oidc handles the authentication piece that was here */

  private loadEntitlements() {
    try {
      this.entitlementsService.loadEntitlements()
        .pipe(takeUntil(this.destroy$))
        .subscribe(entitlementsResponseSuccess => {
          if (!entitlementsResponseSuccess) {
            this.entitlementsService.clearEntitlementData();
            console.error('entitlement loading failure 1');
            this.router.navigate([{outlets: { eepay: ['error', 403]}}], {replaceUrl: true});
            return;
          }
          this.router.navigate([{outlets: { eepay: 'dashboard'}}], {replaceUrl: true });
          return;
        }, err => {
          this.entitlementsService.clearEntitlementData();
          console.error('entitlement loading failure 2');
          this.router.navigate([{outlets: { eepay: ['error', 500]}}], {replaceUrl: true});
        });
    } catch (err) { // mainly occurs if an API is literally offline
      console.error('entitlement loading failure 3');
      this.router.navigate([{outlets: { eepay: ['error', 403, err]}}], {replaceUrl: true});
    }

  }
}
